<template>
  <div :class="classes" v-loading="loading">
     <pt-page-title :title="currentTitle"></pt-page-title>
     <!-- 批量操作内容 -->
     <component :is="compName" :quantity="quantity" @updateType="updateType" @updateAllSize="updateAllSize" @getCurrentStatusTotal="getCurrentStatusTotal"></component>
  </div>
</template>

<script>
// 组件class前缀
import orderflowHelper from '@/config/order'
import LAB_SAMPLES_RECEIVED from 'cps/lab-order/process/form/LAB_SAMPLES_RECEIVED/index'
import LAB_DNA_READY from 'cps/lab-order/process/form/LAB_DNA_READY/index'
import DATA_ANALYSISED from 'cps/lab-order/process/form/DATA_ANALYSISED/index'
import REPORT_CHECKED_1ST from 'cps/lab-order/process/form/UPLOAD_REPORT/index'
// 成人
import ADULT_LAB_SAMPLES_RECEIVED from 'cps/lab-order/process/form/ADULT/LAB_SAMPLES_RECEIVED/index'
import PREPARED from 'cps/lab-order/process/form/ADULT/PREPARED/index'
import ADULT_REPORT_CHECKED_1ST from 'cps/lab-order/process/form/ADULT/UPLOAD_REPORT/index'
const prefixCls = 'pt-lab-order-lot-operate'
export default {
  name: 'pt-lab-order-lot-operate',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    currentTitle () {
      if (this.nextProcess === 'REPORT_CHECKED_1ST') {
        return '批量上传报告'
      }
      return '批量' + orderflowHelper.formatTargetOrderStatus(this.nextProcess, Boolean(this.$route.query.isAdult))
    },
    compName () {
      if (!this.$route.query.isAdult) {
        return this.nextProcess
      }
      return orderflowHelper.getStatusTag(this.nextProcess, Boolean(this.$route.query.isAdult))
    }
  },
  data () {
    return {
      nextProcess: this.$route.params.status,
      quantity: '',
      loading: false,
      packageType: ''
    }
  },
  watch: {
    packageType (val) {
      this.getCurrentStatusTotal()
    }
  },
  components: {
    LAB_SAMPLES_RECEIVED,
    LAB_DNA_READY,
    DATA_ANALYSISED,
    REPORT_CHECKED_1ST,
    ADULT_LAB_SAMPLES_RECEIVED,
    PREPARED,
    ADULT_REPORT_CHECKED_1ST
  },
  methods: {
    getCurrentStatusTotal () {
      let data = {
        businessOriginArea: '',
        methodIds: [],
        needActionTaskInfo: true,
        pageableParam: { page: 0, size: 50 },
        productIds: [],
        statusTime: [{ startTime: '', endTime: '', orderStatus: 'COMPLETED' }],
        upStreamOrganizationIds: [],
        targetStatus: this.nextProcess,
        packageProductionType: this.packageType
      }
      let funcName = this.$route.query.isAdult ? 'AdultexcludeTask' : 'excludeTask'
      this.$store.dispatch(funcName, data).then(res => {
        console.log('res', res)
        this.quantity = String(res.totalNumber)
      }).catch(err => {
        this.$message.error(err)
      })
    },
    updateAllSize (val) {
      if (val) {
        this.getCurrentStatusTotal()
      }
    },
    updateType (val) {
      this.packageType = val
    }
  },
  created () {
    // 因为上机检测步骤需要按类型获取，可省略该步骤的获取
    if (this.nextProcess && this.nextProcess !== 'DATA_ANALYSISED') {
      this.getCurrentStatusTotal()
    }
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
@import '~less/var.less';
.pt-lab-order-lot-operate{
	.received-title{//本样式在子组件中使用
		font-size: 1rem;
		margin-top:.5rem;
  }
  .el-upload-list{
    max-width: 800px;
  }
  .statistics{
    font-size: 22px;
    font-weight: normal;
		span.num{
      font-size:30px;
      font-weight: bold;
			color:@mainColor;
		}
	}
	.info-tip{//本样式在子组件中使用
    color:red;
    font-size: 12px;
    padding:10px 0;
  }
  .operate-buttons{
    margin:40px 0 30px;
  }
  .selected{
    .checkboxList{
      margin-top:20px;
    }
  }
}
</style>
